import { render, staticRenderFns } from "./ModerationGrid.vue?vue&type=template&id=67634db5"
import script from "./ModerationGrid.vue?vue&type=script&lang=js"
export * from "./ModerationGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports